// extracted by mini-css-extract-plugin
export var assigneeBadge = "_o1-0";
export var assigneeDetails = "_o1-1";
export var assigneeInfo = "_o1-2";
export var dropdownContainer = "_o1-4";
export var dropdownImage = "_o1-5";
export var editAssigneeInfo = "_o1-3";
export var editAssigneeModalContainer = "_o1-6";
export var hidden = "_o1-8";
export var input = "_o1-7";